import * as actionTypes from './actionTypes';

export const login = (username, password, otp = '') => ({
  type: actionTypes.LOGIN,
  username,
  password,
  otp,
});
export const loginRequire2Fa = () => ({
  type: actionTypes.LOGIN_REQUIRE_2FA,
});
export const loginSuccess = (token) => ({
  type: actionTypes.LOGIN_SUCCESS,
  token,
});
export const loginError = (error) => ({
  type: actionTypes.LOGIN_ERROR,
  error,
});

export const sso = (retryCount = 0) => ({
  type: actionTypes.SSO,
  retryCount,
});

export const ssoError = () => ({
  type: actionTypes.SSO_ERROR,
});
export const ssoSuccess = () => ({
  type: actionTypes.SSO_SUCCESS,
});

export const logout = (destination = '/login') => ({
  type: actionTypes.LOGOUT,
  destination,
});
export const logoutSuccess = () => ({
  type: actionTypes.LOGOUT_SUCCESS,
});

export const fetchMyUser = () => ({
  type: actionTypes.FETCH_MY_USER,
});
export const fetchMyUserSuccess = (id) => ({
  type: actionTypes.FETCH_MY_USER_SUCCESS,
  id,
});

export const setLoginDestination = (destination) => ({
  type: actionTypes.SET_LOGIN_DESTINATION,
  destination,
});


export const forgotPassword = (email) => ({
  type: actionTypes.FORGOT_PASSWORD,
  email,
});
export const forgotPasswordSuccess = () => ({
  type: actionTypes.FORGOT_PASSWORD_SUCCESS,
});
export const forgotPasswordError = (error) => ({
  type: actionTypes.FORGOT_PASSWORD_ERROR,
  error,
});


export const resetPassword = (data) => ({
  type: actionTypes.RESET_PASSWORD,
  data,
});
export const resetPasswordSuccess = () => ({
  type: actionTypes.RESET_PASSWORD_SUCCESS,
});
export const resetPasswordError = (error) => ({
  type: actionTypes.RESET_PASSWORD_ERROR,
  error,
});

export const changePassword = (oldPassword, newPassword) => ({
  type: actionTypes.CHANGE_PASSWORD,
  oldPassword,
  newPassword,
});
export const changePasswordSuccess = () => ({
  type: actionTypes.CHANGE_PASSWORD_SUCCESS,
});
export const changePasswordError = (error) => ({
  type: actionTypes.CHANGE_PASSWORD_ERROR,
  error,
});


export const verifyResetToken = (token) => ({
  type: actionTypes.VERIFY_TOKEN,
  token,
});
export const verifyResetTokenSuccess = () => ({
  type: actionTypes.VERIFY_TOKEN_SUCCESS,
});
export const verifyResetTokenError = (error) => ({
  type: actionTypes.VERIFY_TOKEN_ERROR,
  error,
});


export const verifyResetAuthCode = (authCode, token) => ({
  type: actionTypes.VERIFY_RESET_CODE,
  authCode,
  token,
});
export const verifyResetAuthCodeSuccess = () => ({
  type: actionTypes.VERIFY_RESET_CODE_SUCCESS,
});
export const verifyResetAuthCodeError = (error) => ({
  type: actionTypes.VERIFY_RESET_CODE_ERROR,
  error,
});


export const init2Fa = () => ({
  type: actionTypes.INIT_2FA,
});
export const init2FaSuccess = (qrCodeUrl, secret) => ({
  type: actionTypes.INIT_2FA_SUCCESS,
  qrCodeUrl,
  secret,
});
export const init2FaError = (error) => ({
  type: actionTypes.INIT_2FA_ERROR,
  error,
});


export const enable2Fa = (otp, secret) => ({
  type: actionTypes.ENABLE_2FA,
  otp,
  secret,
});
export const enable2FaSuccess = (user) => ({
  type: actionTypes.ENABLE_2FA_SUCCESS,
  user,
});
export const enable2FaError = (error) => ({
  type: actionTypes.ENABLE_2FA_ERROR,
  error,
});
